import { AutogenModelProhibited, AutogenRowProhibited } from "./autogen/AutogenModelProhibited";

export class ModelProhibited extends AutogenModelProhibited<RowProhibited> {
	constructor() {
		super(RowProhibited);
	}
}

export class RowProhibited extends AutogenRowProhibited {
}